import type { FC, JSX } from 'react';


import { useSession } from '@eneco/auth';
import { useRouter } from '@eneco/next';
import { NEXT_LOCALE_COOKIE } from '@eneco/next/constants';
import { NavLink } from '@eneco/sparky';
import Cookies from 'js-cookie';
import { signIn } from 'next-auth/react';

export const LoginButton: FC<Props> = ({
  leftIcon,
  label: signInLabel = 'Inloggen',
  callbackUrl,
  sendLocale = false,
}) => {
  const { data: session, status } = useSession() ?? {};
  const { basePath } = useRouter();
  let authorizationParams = {};

  if (sendLocale) {
    const locale = Cookies.get(NEXT_LOCALE_COOKIE) || 'nl';
    authorizationParams = { language: locale };
  }

  if (session || status === 'loading') {
    return null;
  }

  return (
    <NavLink
      leftIcon={leftIcon}
      onClick={() =>
        signIn(
          'okta',
          {
            callbackUrl: `${basePath}${callbackUrl}`,
          },
          authorizationParams,
        )
      }>
      {signInLabel}
    </NavLink>
  );
};

interface Props {
  leftIcon?: JSX.Element;
  label?: string;
  callbackUrl?: string;
  sendLocale?: boolean;
}
